import { TextField } from '@backstage/ui';

interface DisplayNameInputProps {
  entityKind: string;
  displayName: string;
  setDisplayName: (name: string) => void;
  isInvalid?: boolean;
  description?: string;
}

export const DisplayNameInput = (props: DisplayNameInputProps) => {
  const {
    entityKind,
    displayName,
    setDisplayName,
    isInvalid = false,
    description,
  } = props;

  return (
    <TextField
      isInvalid={isInvalid}
      description={description}
      name={`${entityKind.toLowerCase()}DisplayName`}
      label={`${entityKind} Display Name`}
      isRequired
      type="text"
      value={displayName}
      onChange={value => setDisplayName(value)}
    />
  );
};
